
import {NgModule, SystemJsNgModuleLoader} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ModalsAndAlertsComponent} from './abs-modals-and-alerts.component';
import {AbsModalsAndAlertsContentComponent} from './abs-modals-and-alerts-content.component';
import {AbsModalsAndAlertsWrapperDirective} from '../abs-utilities/abs-modals-and-alerts-wrapper.directive';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [ModalsAndAlertsComponent, AbsModalsAndAlertsContentComponent, AbsModalsAndAlertsWrapperDirective],
    exports: [ModalsAndAlertsComponent, AbsModalsAndAlertsContentComponent, AbsModalsAndAlertsWrapperDirective]
})

export class AbsModalsAndAlertsModule {}